"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE_CHANGE_TYPE = exports.SIZE = exports.ENHANCER_POSITION = exports.CUSTOM_INPUT_TYPE = exports.ADJOINED = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STATE_CHANGE_TYPE = {
  change: 'change'
};
exports.STATE_CHANGE_TYPE = STATE_CHANGE_TYPE;
var CUSTOM_INPUT_TYPE = {
  textarea: 'textarea'
};
exports.CUSTOM_INPUT_TYPE = CUSTOM_INPUT_TYPE;
var ADJOINED = {
  none: 'none',
  left: 'left',
  right: 'right',
  both: 'both'
};
exports.ADJOINED = ADJOINED;
var SIZE = {
  mini: 'mini',
  default: 'default',
  compact: 'compact',
  large: 'large'
};
exports.SIZE = SIZE;
var ENHANCER_POSITION = {
  start: 'start',
  end: 'end'
};
exports.ENHANCER_POSITION = ENHANCER_POSITION;